/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_HintInputs */

const cs_gdpr_review_hint = /** @type {(inputs: Gdpr_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienti a leady bez aktivity 2,5 roku. Po 3 letech se automaticky anonymizují, pokud je neoznačíte „Ponechat“ s důvodem (např. platná smlouva).`)
};

const en_gdpr_review_hint = /** @type {(inputs: Gdpr_Review_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients and leads without activity for 2.5 years. After 3 years they are anonymised automatically unless you mark them “Keep” with a reason (e.g. an active contract).`)
};

/**
* | output |
* | --- |
* | "Clients and leads without activity for 2.5 years. After 3 years they are anonymised automatically unless you mark them “Keep” with a reason (e.g. an active c..." |
*
* @param {Gdpr_Review_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_hint = /** @type {((inputs?: Gdpr_Review_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_hint(inputs)
	return cs_gdpr_review_hint(inputs)
});